import * as ambassadorWixAssetsV1SiteScript from './assets-v1-site-script-scripts.http.js';
import * as ambassadorWixAssetsV1SiteScriptTypes from './assets-v1-site-script-scripts.types.js';
import * as ambassadorWixAssetsV1SiteScriptUniversalTypes from './assets-v1-site-script-scripts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listSiteScripts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAssetsV1SiteScriptUniversalTypes.ListSiteScriptsRequest,
  ambassadorWixAssetsV1SiteScriptTypes.ListSiteScriptsRequest,
  ambassadorWixAssetsV1SiteScriptUniversalTypes.ListSiteScriptsResponse,
  ambassadorWixAssetsV1SiteScriptTypes.ListSiteScriptsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAssetsV1SiteScript.listSiteScripts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/site-scripts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEssentialProperties(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAssetsV1SiteScriptUniversalTypes.GetEssentialPropertiesRequest,
  ambassadorWixAssetsV1SiteScriptTypes.GetEssentialPropertiesRequest,
  ambassadorWixAssetsV1SiteScriptUniversalTypes.GetEssentialPropertiesResponse,
  ambassadorWixAssetsV1SiteScriptTypes.GetEssentialPropertiesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAssetsV1SiteScript.getEssentialProperties(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/site-scripts/essentials',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSiteMetadata(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAssetsV1SiteScriptUniversalTypes.GetSiteMetadataRequest,
  ambassadorWixAssetsV1SiteScriptTypes.GetSiteMetadataRequest,
  ambassadorWixAssetsV1SiteScriptUniversalTypes.GetSiteMetadataResponse,
  ambassadorWixAssetsV1SiteScriptTypes.GetSiteMetadataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAssetsV1SiteScript.getSiteMetadata(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/site-scripts/metadata',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteScript as SiteScriptOriginal,
  PositionOnPage as PositionOnPageOriginal,
  PositionOnPageWithLiterals as PositionOnPageWithLiteralsOriginal,
  ListSiteScriptsRequest as ListSiteScriptsRequestOriginal,
  ListSiteScriptsResponse as ListSiteScriptsResponseOriginal,
  GetEssentialPropertiesRequest as GetEssentialPropertiesRequestOriginal,
  GetEssentialPropertiesResponse as GetEssentialPropertiesResponseOriginal,
  EssentialProperties as EssentialPropertiesOriginal,
  Locale as LocaleOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  GetSiteMetadataRequest as GetSiteMetadataRequestOriginal,
  GetSiteMetadataResponse as GetSiteMetadataResponseOriginal,
} from './assets-v1-site-script-scripts.types.js';
